
//Utils
import { initializeStore } from 'lib/redux';
import { initializeApollo } from 'lib/apollo';
import { TokenValidation } from 'lib/function/token-validation';
import { GET_MY_DATA } from 'lib/graphql';
import { SET_ADDRESS, SET_USER_DATA, SET_CARTS, SET_LOCALE, SET_LOCALES, SET_CATEGORIES } from 'lib/redux/types'
import { Q_CATEGORIES } from 'lib/graphql'

/**
 *
 * @param {*} ctx
 * @param {*} fn => params (token: String, ctx: Object, status: Boolean) //Note: status means is login or not
 * @returns
 */
export const getServerAuthenticated = async (ctx, fn) => {
   //Constant
   const { token, user_status } = await TokenValidation(ctx);
   let { locale } = ctx
   const reduxStore = initializeStore();
   const { dispatch } = reduxStore
   if (user_status) {
      const client = initializeApollo(token);
      try {
         let { data } = await client.query({ query: GET_MY_DATA, variables: { lang: locale } });
         if (data) {
            let { me, addresses, carts, categories } = data;
            dispatch({ type: SET_CARTS, payload: carts });
            dispatch({ type: SET_ADDRESS, payload: addresses });
            dispatch({ type: SET_USER_DATA, payload: me })
            dispatch({ type: SET_CATEGORIES, payload: categories })
            return fn(token, ctx, user_status, reduxStore.getState());
         }
      } catch (error) {
         return { notFound: true }
      }
   } else {
      const client = initializeApollo(token);
      try {
         let { data } = await client.query({ query: Q_CATEGORIES, variables: { lang: locale } });
         if (data) {
            dispatch({ type: SET_CATEGORIES, payload: data?.categories })
            return fn(token, ctx, user_status, reduxStore.getState());
         }
      } catch (error) {
         //!NEED ERROR HANDLING
      }
   }
}

// initialReduxState = reduxStore.getState()